export const CHAT_ROOM_TYPE = {
  ONETOONE: 'one-to-one',
  GROUP: 'group',
} as const;

export type CHAT_ROOM_TYPE_KEY = keyof typeof CHAT_ROOM_TYPE;
export type CHAT_ROOM_TYPE_VALUE = typeof CHAT_ROOM_TYPE[CHAT_ROOM_TYPE_KEY];

export const CHAT_TYPE = {
  DEFAULT: 'default',
  NOTICE: 'notice',
  INFO: 'info',
  ITEM: 'item',
} as const;

export type CHAT_TYPE_KEY = keyof typeof CHAT_TYPE;
export type CHAT_TYPE_VALUE = typeof CHAT_TYPE[CHAT_TYPE_KEY];

export interface IChatRoomList {
  participants: string[];
  cheif: string;
  id?: string;
  createdAt?: Date;
  editedAt?: Date;
  type: CHAT_ROOM_TYPE_VALUE;
  groupThumbnail?: string;
  title?: string;
  description?: string;
}

export interface IChat {
  receiverIds?: string[];
  senderId: string;
  contents: string;
  createdAt?: Date;
  editedAt?: Date;
  imgURL?: string;
  reployChatId?: string;
  id?: string;
  type?: CHAT_TYPE_VALUE;
  itemId?: string;
}

export interface IPersonalChat {
  // 각 유저의 sub-col: chat 안에 있음
  unRead: string[];
}
